const DB_NAME = 'i18n-excel-stash'
const STORE_NAME = 'uploads'
const DB_VERSION = 1
/** The service drops an unpublished staging job after an hour; nothing is resumable past a day. */
const STASH_MAX_AGE_MS = 24 * 60 * 60 * 1000

function openDb() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
      reject(new Error('indexedDB unavailable'))
      return
    }
    const request = indexedDB.open(DB_NAME, DB_VERSION)
    request.onupgradeneeded = () => {
      const db = request.result
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'project' })
      }
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

export async function putExcelUploadStash({
  project,
  idempotencyKey,
  selectedLang,
  fileName,
  file,
}) {
  if (!project || !file || !idempotencyKey) {
    return false
  }
  try {
    const db = await openDb()
    await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite')
      tx.oncomplete = () => resolve()
      tx.onerror = () => reject(tx.error)
      tx.objectStore(STORE_NAME).put({
        project,
        idempotencyKey,
        selectedLang: selectedLang || '',
        fileName: fileName || '',
        file,
        savedAt: Date.now(),
      })
    })
    db.close()
    return true
  } catch (_) {
    return false
  }
}

export async function getExcelUploadStash(project) {
  if (!project) {
    return null
  }
  try {
    const db = await openDb()
    const value = await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readonly')
      const request = tx.objectStore(STORE_NAME).get(project)
      request.onsuccess = () => resolve(request.result || null)
      request.onerror = () => reject(request.error)
    })
    db.close()
    if (value && Date.now() - (value.savedAt || 0) > STASH_MAX_AGE_MS) {
      await clearExcelUploadStash(project)
      return null
    }
    return value
  } catch (_) {
    return null
  }
}

export async function clearExcelUploadStash(project) {
  if (!project) {
    return
  }
  try {
    const db = await openDb()
    await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite')
      tx.oncomplete = () => resolve()
      tx.onerror = () => reject(tx.error)
      tx.objectStore(STORE_NAME).delete(project)
    })
    db.close()
  } catch (_) {
    // ignore quota / private mode
  }
}
